// src/modules/app-views/_apps/appmulti/coupons/seed.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import appService from 'services/appService';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DEFAULT_SEEDS = {
  form: {},
  requiredFields: ['name', 'discount', 'qty', 'expirationDate'],
};

// *******************************************************************************
// MAIN FUNCTION
// *******************************************************************************
async function seedCouponsParameters({ moduleId, storedParameters }) {
  if (!moduleId) return;

  const moduleParams = storedParameters?.modules?.[moduleId];
  if (moduleParams && Object.keys(moduleParams).length > 0) {
    return [];
  }

  const results = [];

  const formResult = await seedForm({ moduleId, defaultData: DEFAULT_SEEDS.form });
  if (formResult) results.push(formResult);

  const requiredFieldsResult = await seedRequiredFields({
    moduleId,
    defaultData: DEFAULT_SEEDS.requiredFields,
  });
  if (requiredFieldsResult) results.push(requiredFieldsResult);

  return results;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default seedCouponsParameters;

// *******************************************************************************
// HELPERS
// *******************************************************************************
async function seedForm({ moduleId, defaultData }) {
  try {
    await appService.updateModulePreferences({ category: 'form', moduleId, data: defaultData });
    return { category: 'form', seeded: true, data: defaultData };
  } catch {
    return { category: 'form', seeded: false };
  }
}

async function seedRequiredFields({ moduleId, defaultData }) {
  try {
    await appService.updateModulePreferences({
      category: 'requiredFields',
      moduleId,
      data: defaultData,
    });
    return { category: 'requiredFields', seeded: true, data: defaultData };
  } catch {
    return { category: 'requiredFields', seeded: false };
  }
}
